import Selectize from "selectize";
import $ from "jquery";

Selectize.define("plugin_custom_class", function (options) {
  options = $.extend(
    {
      errorClass: "error"
    },
    options
  );

  const customItemClass = function (thisRef, options) {
    const self = thisRef;

    thisRef.setup = (function () {
      const original = self.setup;
      return function () {
        const renderItem = self.settings.render.item;
        self.settings.render.item = function (item) {
          const html = renderItem.apply(thisRef, arguments);
          const $html = $(html);

          if (item.error) {
            $html.addClass(options.errorClass);
          }

          // return NEW $html element as HTML string
          return $("<div>").append($html.clone()).html();
        };

        original.apply(self, arguments);
      };
    })();
  };

  customItemClass(this, options);
});
